import { render, staticRenderFns } from "./HighlightCommentSection.vue?vue&type=template&id=435ee926&scoped=true"
import script from "./HighlightCommentSection.vue?vue&type=script&lang=ts"
export * from "./HighlightCommentSection.vue?vue&type=script&lang=ts"
import style0 from "./HighlightCommentSection.vue?vue&type=style&index=0&id=435ee926&prod&lang=scss&scoped=true"
import style1 from "./HighlightCommentSection.vue?vue&type=style&index=1&id=435ee926&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "435ee926",
  null
  
)

export default component.exports